import request from '@/utils/request'

export function getTestResourceList(parameter) {
  return request({
    url: '/train/rest/test_file/get_test_resource_list/' + `${parameter}`,
    method: 'get'
  })
}

export function addTestResource(parameter) {
  return request({
    url: '/train/rest/test_file/add_test_resource',
    method: 'post',
    data: parameter
  })
}

export function updateTestResource(parameter) {
  return request({
    url: '/train/rest/test_file/update_test_resource_name',
    method: 'post',
    data: parameter
  })
}

export function removeTestResource(parameter) {
  return request({
    url: '/train/rest/test_file/remove_test_resource',
    method: 'post',
    data: parameter
  })
}

export function getTestPageFile(parameter) {
  return request({
    url: '/train/rest/test_file/get_page_test_file',
    method: 'get',
    params: parameter
  })
}

export function removeTestFile(parameter) {
  return request({
    url: '/train/rest/test_file/remove_test_file',
    method: 'post',
    data: parameter
  })
}

export function removeTestFiles(parameter) {
  return request({
    url: '/train/rest/test_file/remove_test_files',
    method: 'post',
    data: parameter
  })
}

export function clearAllTestFile(parameter) {
  return request({
    url: '/train/rest/test_file/clear_all_test_file',
    method: 'post',
    data: parameter
  })
}

export function getPage(parameter) {
  return request({
    url: '/train/rest/test_task/get_page',
    method: 'get',
    params: parameter
  })
}

export function addTestTask(parameter) {
  return request({
    url: '/train/rest/test_task/add',
    method: 'post',
    data: parameter
  })
}

export function editTestTask(parameter) {
  return request({
    url: '/train/rest/test_task/update',
    method: 'post',
    data: parameter
  })
}


export function startTesting(parameter) {
  return request({
    url: '/train/rest/test_task/start_testing',
    method: 'post',
    data: parameter
  })
}

export function getListStatus(parameter) {
  return request({
    url: '/train/rest/test_task/get_list_status',
    method: 'post',
    data: parameter
  })
}

export function remove(parameter) {
  return request({
    url: '/train/rest/test_task/remove',
    method: 'post',
    data: parameter
  })
}

export function getTestTypeApi(parameter) {
  return request({
    url: '/train/rest/test_result_file/get_file_type/' + `${parameter.taskId}`,
    method: 'get',
    data: parameter
  })
}

export function getTestIdApi(parameter) {
  return request({
    url: '/train/rest/test_result_file/get_path_list/' + `${parameter.taskId}`,
    method: 'get',
    data: parameter
  })
}

export function getTestListApi(params) {
  return request({
    url: '/train/rest/test_result_file/get_file_page/' + `${params.pageIndex}/`+`${params.pageSize}`,
    method: 'get',
    params
  })
}

export function getTestRestPathListApi(params) {
  return request({
    url: '/train/rest/test_result_file/get_file_paths/'  + `${params.taskId}`,
    method: 'get',
    params
  })
}

export function delTestResultApi(params) {
  return request({
    url: '/train/rest/test_result_file/remove_files',
    method: 'post',
    data:params
  })
}

export function getError(parameter){
  return request({
    url: '/train/rest/test_task/get_break_error/' + `${parameter}`,
    method: 'get',
  })
}

export function getNetworkModel(parameter){
  return request({
    url: '/train/rest/test_result_file/get_network_model/' + `${parameter.taskId}`,
    method: 'get',
    data:parameter
  })
}

export function getSourceTestFile(parameter){
  return request({
    url:'/train/rest/test_result_file/get_source_test_file/'+`${parameter.taskId}`+'/'+`${parameter.fileId}`,
    method:'get',
    data:parameter
  })
}